import { makeAsyncComponent } from 'page-lib/utils/makeAsyncUtils';
export default makeAsyncComponent(() => import('./AdsPanel' /* webpackChunkName: "chunk-ads-panel" */));